var _path, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5L4 14L12 14L12 5",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V2L6 2V4",
    stroke: "current"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 4.5,
    x2: 2,
    y2: 4.5,
    stroke: "current"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 7,
    x2: 6.5,
    y2: 11,
    stroke: "current"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 7,
    x2: 9.5,
    y2: 11,
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5c35e4d6219a41899536b87d1a0d63be.svg";
export { ForwardRef as ReactComponent };